// @flow

import React from 'react';
import { Grid } from 'semantic-ui-react';
import Link from './Link';

type Props = {
  megaMenuOpen: boolean,
  onNavigate: () => any,
  singleLinks: Array<Object>
};

class ProductsMegaMenu extends React.Component<Props> {
  render() {
    return (
      <div
        className={`nav-mega-menu ${
          this.props.megaMenuOpen ? 'nav-mega-menu--open' : ''
        }`}
      >
        <div className="nav-mega-menu__contents">
          <Grid columns={2} className="nav-mega-menu__single-products">
            {this.props.singleLinks.map((link, i) => (
              <Grid.Column
                key={i}
                as={Link}
                target="_blank"
                url={link.url}
                className="nav-mega-menu__item"
              >
                <div className="nav-mega-menu__link">{link.title}</div>
                <p>{link.strapline}</p>
              </Grid.Column>
            ))}
          </Grid>
          <div className="nav-mega-menu__suites">
            <div className="nav-mega-menu__item">
              <span className="nav-mega-menu__link">Other Sites</span>
              <p className="nav-mega-menu__suite-strapline">
                Login to other Helix Personas sites:
              </p>
              <p>
                <Link
                  url="http://helixpersonas.co.id"
                  target="_blank"
                  className="nav-mega-menu__link nav-mega-menu__link--hover-colour"
                >
                  Helix Personas Indonesia
                </Link>
                <br />
                <Link
                  url="http://helixpersonas.co.nz"
                  target="_blank"
                  className="nav-mega-menu__link nav-mega-menu__link--hover-colour"
                >
                  Helix Personas New Zealand
                </Link>
                <br />
                <Link
                  url="http://helixpersonas2014.com.au"
                  target="_blank"
                  className="nav-mega-menu__link nav-mega-menu__link--hover-colour"
                >
                  Helix Personas 2014
                </Link>
                <br />
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ProductsMegaMenu;
